import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux';

import OrderToFactoryActionModalContainer from './OrderToFactoryActionModalContainer';
import {setMforderOrderToFactoryModal} from '../../../../store/slice/ManufSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '55%', xs: '75%' },
  height: { lg: '55%', xs: '65%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function OrderToFactoryActionModal() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {orderToFactoryModalOpen, mforderObj} = useSelector((state)=>state.manufslice.mforderDashboard);

  useEffect(()=>{
  },[orderToFactoryModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setMforderOrderToFactoryModal(false));
    if (mforderObj.orderstatusname=='PRODUCTION'){
      navigate('/mforder');
    }
  }
  return (
    <Modal
       open={orderToFactoryModalOpen===undefined?false:orderToFactoryModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5"  >
              Order To Factory @ Order #{mforderObj.id}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item>
          <Divider />
          <Box height="20px"></Box>
        </Grid>
        <Grid item>
            < OrderToFactoryActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}